/** A buyer's screens, in the order the tabs and the home page list them. */
export const SCREENS = [
  { path: 'mills', label: 'Mills' },
  { path: 'suppliers', label: 'Suppliers' },
  { path: 'ingredients', label: 'Ingredients' },
  { path: 'futures', label: 'Futures' },
  { path: 'hedging', label: 'Hedging' },
  { path: 'requirements', label: 'Requirements' },
];
